// Language switcher for the authenticated app — flips the locale store
// (preference-based), unlike the marketing LangSwitcher which navigates
// between localized URLs.

import { LOCALES, LOCALE_LABELS } from "@/i18n/config";
import { useLocaleStore } from "@/stores/localeStore";

export function AppLangSwitcher({ className = "" }: { className?: string }) {
  const locale = useLocaleStore((s) => s.locale);
  const setLocale = useLocaleStore((s) => s.setLocale);
  return (
    <div className={"flex items-center gap-1 font-mono text-[10px] " + className}>
      {LOCALES.map((loc, i) => (
        <span key={loc} className="flex items-center gap-1">
          {i > 0 && <span className="text-dim">/</span>}
          <button
            type="button"
            onClick={() => setLocale(loc)}
            aria-pressed={loc === locale}
            className={
              loc === locale
                ? "text-accent"
                : "text-muted hover:text-content transition-colors"
            }
          >
            {LOCALE_LABELS[loc]}
          </button>
        </span>
      ))}
    </div>
  );
}
